import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['toggler', 'container', 'areaCodeSelect', 'destroyField'];
  static values = { newForm: { type: Boolean, default: true } };

  async connect() {
    // Make the area code select required if the container is not initially hidden.
    if (!this.containerTarget.hidden) {
      await customElements.whenDefined('awc-autocomplete');
      this.areaCodeSelectTarget.required = true;
      return;
    }

    if (this.hasAreaCodeSelectTarget) {
      await customElements.whenDefined('awc-autocomplete');
      this.areaCodeSelectTarget.required = false;
    }
  }

  toggle() {
    if (this.containerTarget.hidden) {
      this.containerTarget.hidden = false;
      this.areaCodeRequired = true;
      if (this.newFormValue) {
        // Remove the `_destroy` field's value.
        this.destroyFieldValue = null;
      }
    } else {
      this.containerTarget.hidden = true;
      if (!this.hasAreaCodeSelectTarget) return;
      this.areaCodeRequired = false;
      if (this.newFormValue) {
        // Only clear select field if it is a new form.
        this.areaCodeSelectTarget.clear();
        // We also need to set the `_destroy` field's value.
        this.destroyFieldValue = '1';
      }
    }
  }

  set areaCodeRequired(value) {
    if (this.hasAreaCodeSelectTarget) {
      this.areaCodeSelectTarget.required = value;
    }
  }

  set destroyFieldValue(value) {
    if (!this.hasDestroyFieldTarget) return;
    const lastField = this.destroyFieldTargets[this.destroyFieldTargets.length - 1];
    if (!value) {
      lastField.removeAttribute('value');
      return;
    }

    lastField.value = value;
  }
}
